import { Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';
import AveragePriceByChildAgePoverty from './AveragePriceByChildAgePoverty';
import AveragePriceBySettingTypePoverty from './AveragePriceBySettingTypePoverty';
import AveragePricePoverty from './AveragePricePoverty';
import ErrorBoundary from '../ErrorBoundary';

function Q1Row2() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    }
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <Grid
        spacing={2}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >

        <Grid item xs={12}>
          <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
            Affordability of care at FPL by family type
          </Typography>
        </Grid>
        <Grid item xs={10} sm={7}>
          <MessageBox>
            <Typography variant="body1" align="left">
              <ErrorBoundary>
                <AveragePricePoverty />
              </ErrorBoundary>
            </Typography>
          </MessageBox>
        </Grid>
        <Grid item xs={12} sm={6} align="center">
          <ErrorBoundary>
            <AveragePriceBySettingTypePoverty height={200} />
          </ErrorBoundary>
        </Grid>
        <Grid item xs={12} sm={6} align="center">
          <ErrorBoundary>
            <AveragePriceByChildAgePoverty height={200} />
          </ErrorBoundary>
        </Grid>
      </Grid>
    </SubquestionBox>
  );
}

export default Q1Row2;
